import { render, staticRenderFns } from "./PoweredBy.vue?vue&type=template&id=25fa8b37&scoped=true"
import script from "./PoweredBy.vue?vue&type=script&lang=ts"
export * from "./PoweredBy.vue?vue&type=script&lang=ts"
import style0 from "./PoweredBy.vue?vue&type=style&index=0&id=25fa8b37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fa8b37",
  null
  
)

export default component.exports